import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
  signal,
} from '@angular/core';
import { BaseCardComponent } from '../../atoms/cards/base-card/base-card.component';
import { HeaderCardComponent } from '../../molecules/header-card/header-card.component';
import { VerticalTabsComponent } from '../../atoms/vertical-tabs/verticals-tabs.component';
import { Tab } from '@ui';
import { AlarmsActiveTableComponent } from '../../molecules/alarms-active-table/alarms-active-table.component';
import { Device } from '@data';

@Component({
  selector: 'ui-alarms-active-menu',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    BaseCardComponent,
    HeaderCardComponent,
    VerticalTabsComponent,
    AlarmsActiveTableComponent,
  ],
  template: `
    <ui-base-card [width]="'full'" [class]="'!items-start'">
      <ng-container content>
        <div class="grid grid-cols-12 grid-rows-1 gap-0">
          <div class="flex flex-col gap-y-14 col-span-4">
            <ui-header-card
              class="pr-4"
              [title]="title()"
              [subtitle]="subtitle()"
              [infoLabel]="infoLabel()"
              [icon]="icon()"
              [iconClass]="iconClass()"
            />
            @if (tabs().length) {
              <div class="pb-4">
                <ui-vertical-tabs
                  [tabs]="tabs()"
                  (onTabClick)="emitDevice($event)"
                />
              </div>
            }
          </div>

          <div class="col-span-8">
            <div class="border border-neutral-4 rounded-lg py-6 px-10 h-full">
              <ui-alarms-active-table [columns]="columns()" [rows]="rows()" [loading]="loading()"/>
            </div>
          </div>
        </div>
      </ng-container>
    </ui-base-card>
  `,
})
export class AlarmsActiveMenuComponent {
  title = input.required<string>();
  subtitle = input.required<string>();
  infoLabel = input.required<string>();
  tabs = input.required<Tab[]>();
  columns = input<string[]>([]);
  rows = input<{ name: string; values: number[] }[]>([]);
  onDevice = output<Device>();
  icon = signal<string>('icons:warning');
  iconClass = signal<string>('text-error bg-error-light shadow-custom-error');
  loading = input<boolean>(true);

  /**
   * Emits the selected device based on the provided tab index.
   *
   * @param index - The index of the tab whose device should be emitted.
   * Emits the device's ID as a `Device` object using the `onDevice` event emitter.
   */
  emitDevice(index: number) {
    const device = this.tabs()[index].id as Device;
    this.onDevice.emit(device);
  }
}
